export type AnalyticsSummary = {
  from: number;
  to: number;
  hourly: Array<{ hour: string; stageId: string; runCount: number }>;
  hourlyPlayers: Array<{ hour: string; playerCount: number }>;
  daily: Array<{ day: string; stageId: string; runCount: number }>;
  dailyPlayers: Array<{ day: string; playerCount: number }>;
  stages: Array<{ stageId: string; runCount: number }>;
  nodes: Array<{ stageId: string; nodeId: string; gameoverCount: number; abandonedCount: number }>;
};

async function parseError(response: Response): Promise<string> {
  const body: unknown = await response.json().catch(() => null);
  return typeof body === "object" && body !== null && "error" in body && typeof body.error === "string"
    ? body.error
    : "通信に失敗しました";
}

export async function loginAnalytics(password: string): Promise<void> {
  const response = await fetch("/api/analytics/login", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  if (!response.ok) throw new Error(await parseError(response));
}

export async function loadAnalyticsSummary(from: number, to: number): Promise<AnalyticsSummary> {
  const response = await fetch(`/api/analytics/summary?from=${from}&to=${to}`, { credentials: "include" });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json() as Promise<AnalyticsSummary>;
}
